<main class="auth-layout">
  <div class="auth-container">
    <img class="auth-logo" src="/images/snelwoningruil-logo.png" alt="logo" />
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</main>
